export const getSimulatedTime = state => state.app.simulatedTime;
export const getIsSimulatedTime = state => state.app.isSimulatedTime;
export const getTimezoneOffset = state => state.app.timezoneOffset;
export const getOffset = state => state.app.offset;
export const getServerMidnight = state => state.app.serverMidnight;
export const getIsClockSyncing = state => state.app.isClockSyncing;
export const getIsAuthorized = state => state.app.isAuthorized;
